import React from "react";

import { ITags } from "../../../../types/tags.type";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import ViewInput from "../inputs/ViewInput/ViewInput";
import styles from "./styles.module.scss";
interface Props {
  tag: ITags;
  onClose: () => void;
  onPressEdit: () => void;
}

const ViewTagForm: React.FC<Props> = (props) => {
  return (
    <div>
      {props.tag.note && (
        <div className={styles.form}>
          <ViewInput title="Примітка" value={props.tag.note} isBig={true} />
        </div>
      )}
      <ModalBottomButtons
        backTitle="Назад"
        onPressBack={props.onClose}
        applyTitle="Редагувати"
        onPressApply={props.onPressEdit}
      />
    </div>
  );
};

export default ViewTagForm;
